module.exports = __webpack_public_path__ + "static/lemon-2f8077590bc91dd5a6acd59d0470ab85.png";